import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EvaluationSheetResultFieldsFragment } from '../../../../../../../../../../../generated/core-api/graphql-react-query';
import useRatioFormat from '../../../../../../../../../../../Hooks/useRatioFormat';
import useEvaluationSheetCsvRows from '../Hooks/useEvaluationSheetCsvRows';
import downloadCsv from '../utils/downloadCsv';
import StyledBox from './styles';

interface SessionEvaluationSheetResultItemProps {
  sheet: EvaluationSheetResultFieldsFragment | null;
  // eslint-disable-next-line no-unused-vars
  setEvaluationSheetDetails: (sheet: EvaluationSheetResultFieldsFragment | null) => void;
}
export default function SessionEvaluationSheetResultItem(props: SessionEvaluationSheetResultItemProps) {
  const { sheet, setEvaluationSheetDetails } = props;
  const { t: tCommon } = useTranslation('common');
  const percentFormat = useRatioFormat('percent');
  const { rows: csvRows } = useEvaluationSheetCsvRows(sheet);

  if (!sheet) return null;
  return (
    <StyledBox>
      <Box>
        <Typography variant="subtitle2">
          {sheet.evaluationSheet.name}
        </Typography>
        <Typography className="point">
          ·
        </Typography>
        <Typography variant="caption">
          {percentFormat.format({
            numerator: sheet.num ?? 0,
            denominator: sheet.denom ?? 0,
          })}
        </Typography>
        <Typography className="point">
          ·
        </Typography>
        <Button
          variant="text"
          className="sheet-button"
          title={tCommon('View details')}
          onClick={() => setEvaluationSheetDetails(sheet)}
        >
          {tCommon('View details')}
        </Button>
      </Box>
      <Button
        variant="outlined"
        title={tCommon('export-csv')}
        onClick={() => downloadCsv(
          `EvaluationSheet-${sheet?.evaluationSheet?.name}.csv`,
          csvRows,
        )}
        disabled={!sheet || csvRows.length === 0}
      >
        {tCommon('export-csv')}
      </Button>
    </StyledBox>
  );
}
